const getApiHost = (env) => {
  switch (env) {
    case 'local':
      return '__LOCALAPIHOST__';
    case 'test':
      return 'https://api.storytelbridge.com/web-page-api/client';
    default:
      return 'https://api.storytel.net/web-page-api/client';
  }
};

module.exports = { getApiHost };
